module.exports = __webpack_public_path__ + "static/accounts_gcp_2-8abf4dd7252a2d5333fd720a871fc44b.png";